module.exports = __webpack_public_path__ + "img/mariage-2-vignette.15324296.jpg";